<template>
  <a
    class="sc-button"
    :class="buttonClassList"
    :href="href"
    v-if="route"
    @click="handleLinkClick($event)"
  >
    <slot></slot>
  </a>
  <button class="sc-button" :class="buttonClassList" :disabled="disabled" v-on="$listeners" v-else>
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: ["route", "variant", "icon", "disabled", "size"],
  computed: {
    buttonClassList() {
      return [this.variant, { icon: this.icon }, this.size];
    },
    href() {
      if (!this.route) {
        return "#";
      }

      const route = this.$router.resolve(this.route);

      return route.href;
    }
  },
  methods: {
    handleLinkClick(event) {
      event.preventDefault();

      this.$emit("click");

      this.$router.push(this.route);
    }
  }
};
</script>

<style lang="scss">
@import "~@/lib/scss/variables";

.sc-button {
  display: inline-block;

  border-radius: $border-radius;
  border: $border;
  min-width: 120px;
  padding: 8px $space;

  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  line-height: 1.29;

  cursor: pointer;
  background: white;

  &.sm {
    font-size: 0.8rem;
    padding: 6px 12px;
    min-width: 80px;
  }

  &:hover:not(:disabled) {
    border-color: $primary-color;

    text-decoration: none;

    background: #eee;
  }

  &:focus:not(:disabled) {
    outline: 0;

    border-color: $primary-color;
  }
}

.sc-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.sc-button.clean {
  border: 0;
  border-color: transparent;
}

.sc-button.icon {
  min-width: auto;

  border-radius: 50%;

  width: 40px;
  height: 40px;
  padding: 0;
}

$variants: (primary $primary-color $primary-dark-color),
  (secondary $secondary-color $secondary-dark-color),
  (warning $warning-color $warning-dark-color),
  (success $success-color $success-dark-color),
  (danger $danger-color $danger-dark-color),
  (amber $amber-color $amber-dark-color),
  (orange-cc $orange-cc-color $orange-cc-dark-color),
  (white-orange $white $orange-cc-dark-color);

@each $variant in $variants {
  $name: nth($variant, 1);
  $color: nth($variant, 2);
  $dark-color: nth($variant, 3);

  .sc-button.#{$name} {
    border-radius: $border-radius;
    color: white;

    background: $color;
    border-color: $color;
    box-shadow: $shadow-1dp;

    &:hover:not(:disabled) {
      background: $dark-color;
      border-color: $dark-color;
    }

    &:focus:not(:disabled) {
      border-color: $color;
    }
  }

  .sc-button.#{$name}:disabled {
    background: desaturate($color, 50);
    border-color: desaturate($color, 50);
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/ScButton.vue